module.exports = __webpack_public_path__ + "media/app/components/InvitationReviewStores/Edit.e9a059a9.svg";